module.exports = __webpack_public_path__ + "img/welding-10.8f7125e0.jpg";